import uuidv4 from 'uuid/v4';

export const createFaq = (label, order) => ({
  id: uuidv4().slice(0, 6),
  order,
  label,
  isDeleted: false,
  content: [],
});

export const createFaqQuestion = order => ({
  id: uuidv4().slice(0, 6),
  order,
  question: '',
  answer: '',
});

export const faqEditingInitialState = {
  sectionId: null,
  id: null,
  qa: null,
  key: null,
};
